import { getAnalytics, logEvent } from 'firebase/analytics';

// Get the Firebase Analytics instance
const firebaseAnalytics = getAnalytics();

// Initialize Firebase Analytics (already done in firebase.js)
export const initGA = () => {
  // Firebase Analytics is already initialized in firebase.js
  console.log('Firebase Analytics is active with Measurement ID: G-0KXF4BCGKW');
};

// Log page views
export const logPageView = (page) => {
  logEvent(firebaseAnalytics, 'page_view', {
    page_path: page,
    page_title: document.title
  });
};

// Log custom events
export const logCustomEvent = (category, action, label = null, value = null) => {
  const eventParams = {
    event_category: category,
    event_action: action
  };

  if (label) eventParams.event_label = label;
  if (value) eventParams.value = value;

  logEvent(firebaseAnalytics, 'custom_event', eventParams);
};

// Predefined event helpers for common actions
export const logProjectView = (projectName, projectType) => {
  logEvent(firebaseAnalytics, 'project_view', {
    project_name: projectName,
    project_type: projectType
  });
};

export const logContactFormSubmit = (formType = 'general') => {
  logEvent(firebaseAnalytics, 'contact_form_submit', {
    form_type: formType
  });
};

export const logProjectInquiry = (projectName) => {
  logEvent(firebaseAnalytics, 'project_inquiry', {
    project_name: projectName
  });
};